module.exports = __webpack_public_path__ + "static/media/32.9c58bcd4.png";